import { createSlice } from '@reduxjs/toolkit';
import { GET_ULTIMATE_SEARCH_RESULTS } from '../../../actions-index';
import { ERROR_CONSTS } from '../../../util/constants';

// ---------------------------------------------------------------------------
// ultimateSearchReducer slice
// ---------------------------------------------------------------------------
const initialState = {
  status: '',
  alert: ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
};

const ultimateSearchSlice = createSlice({
  name: 'ultimateSearchReducer',
  initialState: {
    status: '',
    alert: ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
    data: {},
    type: GET_ULTIMATE_SEARCH_RESULTS,
  },
  reducers: {
    cleanupSearchResults() {
      return initialState;
    },
    getUltimateSearchResults(state, action) {
      state.searchResults = {
        status: action.payload.status,
        alert: action.payload.alert,
        data: action.payload.data,
        type: GET_ULTIMATE_SEARCH_RESULTS,
      };
    },
  },
});

export const { cleanupSearchResults, getUltimateSearchResults } =
  ultimateSearchSlice.actions;
export const ultimateSearchReducer = ultimateSearchSlice.reducer;
